"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var renderer = function renderer(_ref) {
  var cellData = _ref.cellData;
  var name = cellData.name,
      segments = cellData.segments;

  if (segments.length > 0) {
    return /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.segments"
    }, function (title) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        title: title,
        className: "flex items-center"
      }, name, " ", /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Segments, {
        className: "ml-2 h-6 w-6"
      }));
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", null, name);
};

renderer.propTypes = {
  cellData: _propTypes["default"].string
};
renderer.defaultProps = {
  cellData: ''
};
var _default = renderer;
exports["default"] = _default;